import { Route, Routes } from 'react-router-dom'

import AgencyEdit from './screens/Agencies/screens/Edit'
import AgencyList from './screens/Agencies/screens/List'
import AssetLibraryList from './screens/AssetLibraries/screens/List'
import CampaignQuoteTemplateEdit from './screens/CampaignQuoteTemplates/screens/Edit'
import CampaignQuoteTemplateList from './screens/CampaignQuoteTemplates/screens/List'
import CustomDeadlineList from './screens/CustomDeadlines/screens/List'
import CustomItemList from './screens/CustomItems/screens/List'
import ImageSettings from './screens/ImageSettings/screens/List'
import ImageLibraryList from './screens/ImageLibraries/screens/List'
import Integrations from './screens/Integrations/screens/List'
import ManageProducts from './screens/ManageProducts/screens/List'
import OrderBundleList from './screens/OrderBundles/screens/List'
import PackagesList from './screens/Packages/screens/List'
import PriceListsList from './screens/PriceLists/screens/List'
import ReportingList from './screens/Reporting/screens/List/components/PageContent'
import SavedArtworkList from './screens/SavedArtworks/screens/List'
import Settings from './screens/Settings/screens/List'
import TaskPricingList from './screens/TaskPricing/screens/List'
import TeamEdit from './screens/Teams/screens/Edit'
import TeamList from './screens/Teams/screens/List'
import TemplateGallery from './screens/TemplateGallery/screens/List'
import UserEdit from './screens/Users/screens/Edit'
import UserList from './screens/Users/screens/List'

const AgencyAdminRoutes = () => (
  <Routes>
    <Route path="/agencies" element={<AgencyList />} />
    <Route path="/assetLibraries" element={<AssetLibraryList />} />
    <Route path="/campaignQuoteTemplates" element={<CampaignQuoteTemplateList />} />
    <Route path="/campaignQuoteTemplates/:campaignQuoteTemplateId/edit/*" element={<CampaignQuoteTemplateEdit />} />
    <Route path="/reporting" element={<ReportingList />} />
    <Route path="/customDeadlines" element={<CustomDeadlineList />} />
    <Route path="/customItems" element={<CustomItemList />} />
    <Route path="/details" element={<AgencyEdit />} />
    <Route path="/imageSettings" element={<ImageSettings />} />
    <Route path="/imageLibraries" element={<ImageLibraryList />} />
    <Route path="/integrations" element={<Integrations />} />
    <Route path="/products" element={<ManageProducts />} />
    <Route path="/orderBundles" element={<OrderBundleList />} />
    <Route path="/providerPackages" element={<PackagesList />} />
    <Route path="/providerPriceLists" element={<PriceListsList />} />
    <Route path="/savedArtworks" element={<SavedArtworkList />} />
    <Route path="/settings" element={<Settings />} />
    <Route path="/taskPricing" element={<TaskPricingList />} />
    <Route path="/teams" element={<TeamList />} />
    <Route path="/teams/:teamId/edit/*" element={<TeamEdit />} />
    <Route path="/templateGallery" element={<TemplateGallery />} />
    <Route path="/users" element={<UserList />} />
    <Route path="/users/:userId/edit/*" element={<UserEdit />} />
  </Routes>
)

export default AgencyAdminRoutes
